import { createFileRoute } from "@tanstack/react-router";

import { createParticipantLoaderOptions } from "@/loaders/participant";
import { ParticipantSetup } from "@/pages/participant/setup";

export const Route = createFileRoute("/participate/setup")({
  component: ParticipantSetup,
  loader: ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData(createParticipantLoaderOptions());
  },
});
